import React, { Component } from 'react';
import { Table } from 'react-bootstrap/lib';
import Api from './../../Global/Modules/Api';

const FETCH_URL = 'api/events/'
class TableEvents extends Component {
    constructor() {
        super();
        this.state = {
            events: [],
            displayTable: 'none',
            emptyTable: 'none',
            pagination: {
                totalPages: 0,
                currentPage: 0,
                pageSize: 0,
                totalCount: 0
            }
        }

        this.handleClick = this.handleClick.bind(this);
    }
    componentDidMount() {
        Api.GetTableApi(FETCH_URL, this.handleClick).then(response => {
            if (response.pagination.totalCount === 0) {
                this.setState({ displayTable: "none" })
                this.setState({ emptyTable: "block" })
            } else {
                this.setState({ displayTable: "block" })
                this.setState({ emptyTable: "none" })
            }
            this.setState({ pagination: response.pagination })
            return response.data.json()
        }).then(objectData => {
            Api.print('Table events data')
            Api.print(objectData)
            if (objectData !== undefined) {
                let events = objectData.events.map(function (item, index) {
                    return <tr key={item.id}>
                        <td>{Api.formatDate(item.date)}</td>
                        <td>{item.organization}</td>
                        <td>{item.name}</td>
                        <td>{item.points}</td>
                        <td>{item.website === "" ? "" : <a href={item.website}>website</a>}</td>
                    </tr>
                })
                this.setState({ events })
            }
        })
    }

    handleClick(e) {
        const FETCH_URL2 = e === "prev" ? this.state.pagination.prev : this.state.pagination.next;
        Api.GetTableApi(FETCH_URL2, this.handleClick).then(response => {
            if (response.pagination.totalCount === 0) {
                this.setState({ displayTable: "none" })
                this.setState({ emptyTable: "block" })
            } else {
                this.setState({ displayTable: "block" })
                this.setState({ emptyTable: "none" })
            }
            this.setState({ pagination: response.pagination })
            return response.data.json()
        }).then(objectData => {
            if (objectData !== undefined) {
                let events = objectData.events.map(function (item, index) {
                    return <tr key={item.id}>
                        <td>{Api.formatDate(item.dateCreated)}</td>
                        <td>{item.organization}</td>
                        <td>{item.name}</td>
                        <td>{item.points}</td>
                        <td>{item.website === "" ? "" : <a href={item.website}>website</a>}</td>
                    </tr>
                })
                this.setState({ events })
            }
        })
    }


    render() {
        return (
            <div>
                <div style={{ display: this.state.displayTable }}>
                    <div>Resultaten  {(this.state.pagination.pageSize == '0' || this.state.pagination.pageSize > this.state.pagination.totalCount) ? this.state.pagination.totalCount : this.state.pagination.pageSize} van {this.state.pagination.totalCount}</div>
                    <Table responsive bordered hover striped className="events-table">
                        <thead>
                            <tr>
                                <th>Datum</th>
                                <th>Organisatie</th>
                                <th>Naam bijeenkomst</th>
                                <th>KE/EE punten</th>
                                <th>Website</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.events}
                        </tbody>
                    </Table>
                    <div className="paginationStyling">
                        <div style={{ float: 'left' }}>
                            {this.state.pagination.prevButton}
                        </div>
                        <div style={{ float: 'center' }}>
                            Pagina {this.state.pagination.currentPage} van {this.state.pagination.totalPages}
                        </div>
                        <div style={{ float: 'right' }}>
                            {this.state.pagination.nextButton}
                        </div>
                    </div>
                </div>
                <div style={{ display: this.state.emptyTable }}>
                    <br /> <br />
                    Er zijn geen gegevens beschikbaar
                </div>
            </div>

        );
    }
}

export default TableEvents;



// WEBPACK FOOTER //
// ./src/components/Global/Modules/TableEvents.js